import {
  generateAsyncActionCreators,
} from '../core/reduxUtils';

const getFiltersActionCreators = generateAsyncActionCreators(
  'GET_FILTERS',
  (params, cookies) => ({
    params,
    cookies,
  }),
);

const getSearchFiltersActionCreators = generateAsyncActionCreators(
  'GET_SEARCH_FILTERS',
  (params, cookies, headers) => ({
    params,
    cookies,
    headers,
  }),
);

const getNextFiltersActionCreators = generateAsyncActionCreators(
  'GET_NEXT_FILTERS',
  (facetId, params, cookies) => ({
    facetId,
    params,
    cookies,
  }),
);

const getNextSearchFiltersActionCreators = generateAsyncActionCreators(
  'GET_NEXT_SEARCH_FILTERS',
  (facetId, params, cookies) => ({
    facetId,
    params,
    cookies,
  }),
);

const applyFiltersActionCreators = generateAsyncActionCreators(
  'APPLY_FILTERS',
  (params, cookies) => ({
    params,
    cookies
  }),
);

const applySearchFiltersActionCreators = generateAsyncActionCreators(
  'APPLY_SEARCH_FILTERS',
  (params, cookies) => ({
    params,
    cookies
  }),
);

const applyTagFiltersActionCreators = generateAsyncActionCreators(
  'APPLY_TAG_FILTERS',
  (params, cookies) => ({
    params,
    cookies
  }),
);

const applyBrandFiltersActionCreators = generateAsyncActionCreators(
  'APPLY_BRAND_FILTERS',
  (params) => ({
    params,
  }),
);

const getTagFiltersActionCreators = generateAsyncActionCreators(
  'GET_TAG_FILTERS',
  (params, cookies) => ({
    params,
    cookies,
  }),
);

const getNextTagFiltersActionCreators = generateAsyncActionCreators(
  'GET_NEXT_TAG_FILTERS',
  (facetId, params, cookies) => ({
    facetId,
    params,
    cookies
  }),
);

const getBrandFiltersActionCreators = generateAsyncActionCreators(
  'GET_BRAND_FILTERS',
  (params, cookies) => ({
    params,
    cookies,
  }),
);

const getNextBrandFiltersActionCreators = generateAsyncActionCreators(
  'GET_NEXT_BRAND_FILTERS',
  (facetId, params) => ({
    facetId,
    params,
  }),
);

const getUpdateFilterSelectionActionCreators = generateAsyncActionCreators(
  'GET_UPDATE_FILTER_SELECTION',
  (facetId, filter, isSingleSelection, category) => ({
    facetId,
    filter,
    isSingleSelection,
    category,
  }),
);

const getDeliveryInfoActionCreators = generateAsyncActionCreators(
  'GET_DELIVERY_INFO',
  (params, cookies) => ({
    params,
    cookies,
  }),
);

const getQuickFilterDeliveryInfoActionCreators = generateAsyncActionCreators(
  'GET_QUICK_FILTER_DELIVERY_INFO',
  (params, cookies) => ({
    params,
    cookies,
  }),
);

const getCampaignFilterActionCreators = generateAsyncActionCreators(
  'GET_CAMPAIGN_FILTER',
  (params, cookies) => ({
    params,
    cookies,
  }),
);

const actionCreators = {
  getFilters: {
    ...getFiltersActionCreators,
  },

  getCampaignFilter: {
    ...getCampaignFilterActionCreators,
  },

  getSearchFilters: {
    ...getSearchFiltersActionCreators,
  },

  getNextFilters: {
    ...getNextFiltersActionCreators,
  },

  getNextSearchFilters: {
    ...getNextSearchFiltersActionCreators,
  },

  applyFilters: {
    ...applyFiltersActionCreators,
  },

  applySearchFilters: {
    ...applySearchFiltersActionCreators,
  },

  applyTagFilters: {
    ...applyTagFiltersActionCreators,
  },

  applyBrandFilters: {
    ...applyBrandFiltersActionCreators,
  },

  getTagFilters: {
    ...getTagFiltersActionCreators,
  },

  getNextTagFilters: {
    ...getNextTagFiltersActionCreators,
  },

  getBrandFilters: {
    ...getBrandFiltersActionCreators,
  },

  getNextBrandFilters: {
    ...getNextBrandFiltersActionCreators,
  },

  getUpdateFilterSelection: {
    ...getUpdateFilterSelectionActionCreators,
  },

  getDeliveryInfo: {
    ...getDeliveryInfoActionCreators,
  },

  getQuickFilterDeliveryInfo: {
    ...getQuickFilterDeliveryInfoActionCreators,
  },

  resetFilterState() {
    return {
      type: 'RESET_FILTER_STATE',
      payload: {},
    };
  },

  clearActiveFacetFilters() {
    return {
      type: 'CLEAR_ACTIVE_FACET_FILTERS',
      payload: {},
    };
  },

  clearAllFilters() {
    return {
      type: 'CLEAR_ALL_FILTERS',
      payload: {},
    };
  },

  setAllFiltersClicked(clicked) {
    return {
      type: 'SET_CLEAR_ALL_FILTERS_CLICKED',
      payload: {
        clickedClearAllFilters: clicked,
      },
    };
  },

  openFilterManagementPanel() {
    return {
      type: 'OPEN_FILTER_MANAGEMENT_PANEL',
      payload: {},
    };
  },

  closeFilterManagementPanel(ignoreTolkienForSearchFilters) {
    return {
      type: 'CLOSE_FILTER_MANAGEMENT_PANEL',
      payload: {
        ignoreTolkienCloseForSearchFilters: ignoreTolkienForSearchFilters ? ignoreTolkienForSearchFilters : null,
      },
    };
  },

  setFilterSearchKeyword(type, keyword) {
    return {
      type: 'SET_FILTER_SEARCH_KEYWORD',
      payload: {
        type,
        keyword,
      },
    };
  },

  setAllFilters(type) {
    return {
      type: 'SET_ALL_FILTERS',
      payload: {
        type,
      },
    };
  },

  getFiltersByKeyword(type, keyword) {
    return {
      type: 'GET_FILTERS_BY_KEYWORD',
      payload: {
        type,
        keyword,
      },
    };
  },

  setPriceRange(priceRangeEntry) {
    return {
      type: 'SET_PRICE_FILTER_RANGE',
      payload: {
        priceRangeEntry,
      },
    };
  },

  setWordFilter(keyword) {
    return {
      type: 'SET_WORD_FILTER',
      payload: {
        keyword,
      },
    };
  },

  getNextVisibleFilters(facetId, params) {
    return {
      type: 'GET_NEXT_VISIBLE_FILTERS',
      payload: {
        facetId,
        params,
      },
    };
  },

  setActiveFacet(facet) {
    return {
      type: 'SET_ACTIVE_FACET',
      payload: {
        facet,
      },
    };
  },

  resetActiveFacet() {
    return {
      type: 'RESET_ACTIVE_FACET',
      payload: {},
    };
  },

  restorePreviousFilterState() {
    return {
      type: 'RESTORE_PREVIOUS_FILTER_STATE',
      payload: {},
    };
  },

  setDeliveryCheckboxSettings(settings) {
    return {
      type: 'SET_DELIVERY_SETTINGS',
      payload: {
        settings,
      },
    };
  },

  setDeliveryLocation(location) {
    return {
      type: 'SET_DELIVERY_LOCATION',
      payload: {
        location,
      },
    };
  },

  setSorting(sortItem) {
    return {
      type: 'SET_SORTING',
      payload: {
        sortItem,
      },
    };
  },

  setSelectedFilterCount(selectedFilterCount) {
    return {
      type: 'SET_SELECTED_FILTER_COUNT',
      payload: {
        selectedFilterCount,
      },
    };
  },

  setSelectedFilter(selectedFilter) {
    return {
      type: 'SET_SELECTED_FILTER',
      payload: {
        selectedFilter,
      },
    };
  },

  applySelectedFilter(selectedFilter) {
    return {
      type: 'APPLY_SELECTED_FILTER',
      payload: {
        selectedFilter,
      },
    };
  },

  clearSelectedFilter() {
    return {
      type: 'CLEAR_SELECTED_FILTER',
      payload: {}
    };
  },

  clearApplySelectedFilter() {
    return {
      type: 'CLEAR_APPLY_SELECTED_FILTER',
      payload: {}
    };
  },

  updateURLForRedirection(value) {
    return {
      type: 'UPDATE_URL_FOR_REDIRECTION',
      payload: {
        value
      }
    };
  },
};

export {
  actionCreators,
  applyFiltersActionCreators,
  applySearchFiltersActionCreators,
  applyTagFiltersActionCreators,
  applyBrandFiltersActionCreators,
  getFiltersActionCreators,
  getNextFiltersActionCreators,
  getSearchFiltersActionCreators,
  getNextSearchFiltersActionCreators,
  getTagFiltersActionCreators,
  getNextTagFiltersActionCreators,
  getBrandFiltersActionCreators,
  getNextBrandFiltersActionCreators,
  getUpdateFilterSelectionActionCreators,
  getDeliveryInfoActionCreators,
  getQuickFilterDeliveryInfoActionCreators,
  getCampaignFilterActionCreators,
};
